import { useQuery } from 'react-query';

import { LocationService } from '../../services';
import formatTimeZones from '../../lib/data/timezones';

export const useGetTimezoneOptions = () => {
  return useQuery('timezoneOptions', LocationService.getTimezones, {
    select: formatTimeZones,
  });
};
